

export class Child {
    age?: number;

    constructor() {
        this.age = -1;

    }
}